var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"user-container"},[_c('div',{staticClass:"guest"},[_c('div',{staticClass:"login",on:{"click":_vm.toLogin}},[_vm._v("登录/注册")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/.store/vue-loader@13.7.3/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-63926a85","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/.store/vue-loader@13.7.3/node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/user.vue
// module id = 2kut
// module chunks = 8